import React, { useMemo, useState } from "react";
import { Stack, Typography, Box } from "@mui/material";
import { WorkspaceFolderCloseIcon, WorkspaceFolderOpenIcon } from "assets/material-custom-icons";

import { ArrowTrigger } from "../Arrow-trigger/ArrowTrigger";
import { useImportContext } from "./import-context";
import { IFolderTemplate } from "store/types";
import { Checkbox } from "components/forms";
import { FolderItem } from "./FolderItem";

interface IProps {
  folder: IFolderTemplate;
  allFolders: IFolderTemplate[] | undefined;
  subIndex: number;
}

export const FolderNode: React.FC<IProps> = ({ folder, allFolders, subIndex }) => {
  const [arrowState, setArrowState] = useState(false);
  const { isSelected, selectItem } = useImportContext();
  const checkboxValue = isSelected({ key: "folders", id: folder.id });

  const folderClick = () => {
    setArrowState(!arrowState);
  };
  const children = allFolders?.filter((item) => item.parent_id === folder.id);

  const renderFolderIcon: JSX.Element | undefined = useMemo(() => {
    if (arrowState) {
      return <WorkspaceFolderOpenIcon sx={{ marginRight: "10px", width: "20px", fill: "#5D7782" }} />;
    }
    if (!arrowState) {
      return <WorkspaceFolderCloseIcon sx={{ marginRight: "10px", width: "20px", fill: "#5D7782" }} />;
    }
  }, [arrowState]);

  return (
    <>
      <Stack direction="row" key={folder.id} alignItems="center" sx={{ padding: "9px 0" }} onClick={folderClick}>
        <Checkbox
          value={checkboxValue}
          size="small"
          name={folder.id as any}
          variant="mark-square"
          onChange={() => selectItem({ key: "folders", item: { id: folder.id, parentId: folder.parent_id } })}
        />
        <Box sx={{ marginLeft: `${subIndex * 25 + 7}px`, marginRight: "7px" }}>
          <ArrowTrigger isOpen={arrowState} onClick={folderClick} fill="#0a3142" sx={{ padding: "3px" }} />
        </Box>
        {renderFolderIcon}
        <Typography
          sx={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            width: "200px",
            color: "#173c4c"
          }}
        >
          {folder.title}
        </Typography>
      </Stack>

      {arrowState &&
        folder?.details?.files &&
        folder?.details?.files.map((item, idx) => (
          <FolderItem key={idx} item={item} subIndex={subIndex} folder={folder} />
        ))}

      {arrowState &&
        folder?.details?.forms &&
        folder?.details?.forms.map((item, idx) => (
          <FolderItem key={idx} item={item} subIndex={subIndex} folder={folder} />
        ))}

      {arrowState &&
        children?.map((item, idx) => (
          <FolderNode key={idx} folder={item} allFolders={allFolders} subIndex={subIndex + 1} />
        ))}
    </>
  );
};
